import { Box } from '@mui/material';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { reset, resetBulk } from '../../stores/TransactionsStore';

import PageTitle from '../../components/Text/PageTitle';
import TransactionsTable from './TransactionsTable';

function Transactions() {
  const [t] = useTranslation();
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(resetBulk());

    return () => {
      if (sessionStorage.getItem('navigatingToDetails') !== 'true') {
        dispatch(reset());
      }
      sessionStorage.removeItem('navigatingToDetails');
    };
  }, []);

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <PageTitle>{t('pages.transactions.title')}</PageTitle>
      </Box>
      <TransactionsTable />
    </>
  );
}

export default Transactions;
